import { create } from 'zustand';

// Coordinates between row-click (trigger) and the page-level slide panel
// (consumer). Stores only the id; the panel re-fetches via usePatientQuery.
//
// The panel is read-only (PRD 02 v1.7 — no memo edit, no admin status change),
// so there is no edit-mode / dirty state to track.
interface PatientDetailState {
  openId: number | null;
  open: (id: number) => void;
  close: () => void;
}

export const usePatientDetailStore = create<PatientDetailState>((set) => ({
  openId: null,
  open: (id) => set({ openId: id }),
  close: () => set({ openId: null }),
}));
